<template>
  <div
    class="d-flex flex-wrap"
    style="gap: 10px;"
  >
    <v-btn
      v-if="allowClear"
      icon
      outlined
      width="32"
      height="32"
      :color="!value ? 'primary' : undefined"
      :title="$t('event_colors.reset')"
      @click="$emit('input', null)"
    >
      <v-icon small>
        fal fa-times
      </v-icon>
    </v-btn>
    <v-btn
      v-for="color in palette"
      :key="color"
      icon
      width="32"
      height="32"
      @click="$emit('input', color)"
    >
      <v-avatar
        :color="color"
        size="24"
        :style="value === color ? 'outline: 2px solid currentColor; outline-offset: 2px;' : ''"
      >
        <v-icon
          v-if="value === color"
          x-small
          color="white"
        >
          fal fa-check
        </v-icon>
      </v-avatar>
    </v-btn>
  </div>
</template>

<script>
import { EVENT_COLOR_PALETTE } from '@/data/models'

export default {
  name: 'ColorSwatchPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    palette: EVENT_COLOR_PALETTE
  })
}
</script>
